export const REGEX_ENGLISH_ALPHA = "A-Za-z";
export const REGEX_ENGLISH_CHARACTER = /^[a-zA-Z0-9$@$!%*?&#^-_. +(){};:/<>]+$/;
export const REGEX_ENGLISH_NUMBER = "0-9";
export const REGEX_ARABIC_ALPHA = "\u0629\u0643\u0649-\u064B\u064D\u06D5";
export const REGEX_ARABIC_NUMBER = "\u0660-\u0669";
export const REGEX_IRAN_MOBILE = /^09\d{9}$/;
export const REGEX_IRAN_NATIONAL_CODE = /^\d{10}$/;
export const REGEX_IRAN_TELEPHONE = /^0\d{2,3}\d{8}$/;
export const REGEX_JALALI_DATE = /^(12|13|14)\d{2}-\d{2}-\d{2}$/;
export const REGEX_PERSIAN_ALPHA = "\u0621-\u0628\u062A-\u063A\u0641-\u0642\u0644-\u0648\u064E-\u0651\u0655\u067E\u0686\u0698\u06A9\u06AF\u06BE\u06CC";
export const REGEX_PERSIAN_MARK = "\u060C\u061B\u061F\u0640\u066A\u066B\u066C";
export const REGEX_PERSIAN_NUMBER = "\u06F0-\u06F9";
export const REGEX_WORD_CHARACER = /[آ-یA-z0-9]/g;
export const REGEX_SPACE = "\u0020\u2000-\u200F\u2028-\u202F";
export const REGEX_HALF_SPACE = /(\u200c|\u202f)/g;
export const REGEX_ULR = /^(ftp|http|https):\/\/[^ "]+$/;
export const REGEX_CHECK_URL_HTTP = /^https?:\/\/igap\.net\/(.+)/i;
export const REGEX_CHECK_URL = /^igap\.net\/(.+)/i;
export const REGEX_IS_INTERNAL_LINK = /(discovery|igap|iGap).net|igap:\/\/(discovery)/g;
export const REGEX_IS_INVITE_LINK = /igap:\/\/join/g;
export const REGEX_IS_INVITE_PROFILE_LINK = /((https\:\/\/)|profile\.)igap\.net\/join\//gi;
export const REGEX_DISCOVERY = /igap:\/\/discovery\//g;
export const REGEX_INTERNAL_DISCOVERY = /(igap|iGap|discovery)/g;
export const REGEX_TgADDR = /^(web\+)?igap:(\/\/)?(.+)/i;
export const REGEX_INVITE_LINK = /^join\?invite=(.+)$/;
export const REGEX_RESOLVE_LINK = /^resolve\/?\?domain=(.+?)(?:&(start|startgroup|post)=(.+))?$/;
export const REGEX_BOLD_CHARACTER = /\*\*[^\s](.*)[^\s]\*\*/gim;
export const REGEX_BOT_LINK = /(\/)\D\w+/g;
export const REGEX_BEFORE_DOT = /^(.+?)[.]/;
export const REGEX_A2HS_TABLET = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i;
export const REGEX_A2HS_MOBILE = /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/;
export const REGEX_ALL_INVITE_LINK = /^(https?:\/\/)?(profile\.)?igap\.net\/(join\/)?/gim;
export const REGEX_INVITE_PROFILE_LINK = /^igap:\/\/(join)\//gim;
export const REGEX_PROFILE_LINKE_TOKEN = /^(https?:\/\/)?(profile\.)?igap\.net\/(join\/)?/gim;
